import { Badge } from "@/components/ui/badge";
import { Gauge, TrendingUp } from "lucide-react";

export default function GrowthScoreCard({ score }) {
  if (!score) return null;
  return (
    <div data-testid="growth-score" className="lg:col-span-1 bg-white border border-zinc-200 rounded-2xl p-6">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-500">
        <Gauge className="h-4 w-4 text-indigo-600" /> Growth Score
      </div>
      <div className="mt-3 flex items-baseline gap-3">
        <div className="font-display font-black text-6xl text-zinc-900 leading-none">{score.overall}</div>
        <div className="text-zinc-500">/ 100</div>
        {score.grade && <Badge className="ml-auto bg-indigo-600">Grade {score.grade}</Badge>}
      </div>
      <div className="mt-4 space-y-2">
        {Object.entries(score.subscores || {}).map(([k, v]) => (
          <div key={k}>
            <div className="flex justify-between text-xs text-zinc-600 mb-1">
              <span className="capitalize">{k.replace(/_/g, " ")}</span>
              <span className="font-medium">{v}</span>
            </div>
            <div className="h-1.5 bg-zinc-100 rounded-full overflow-hidden">
              <div className="h-full bg-indigo-600 progress-line" style={{ width: `${v}%` }} />
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-zinc-500 mt-4">{score.rationale}</p>
      {score.boosters?.length > 0 && (
        <div className="mt-4 border-t border-zinc-100 pt-3">
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2">Raise score by</div>
          <ul className="space-y-1.5 text-sm">
            {score.boosters.map((b, i) => (
              <li key={`booster-${i}-${b.slice(0, 24)}`} className="flex gap-2 text-zinc-800">
                <TrendingUp className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" /> {b}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
